import React, { useState } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { PromotionIcon } from 'images';
import { selectCostcoVariables } from 'containers/Landing/selectors';
import { replaceAllVariables } from 'utils/translation';
import { setTheme } from 'utils/themeHelper';
import { Button } from 'components/Ui';
import CostcoPromotionDetails from './CostcoPromotionDetails';
import { COSTCO_PROMOTION_LEARN } from '../constants';
import styles from './styles.scss';

/* eslint-disable prettier/prettier */
const CostcoPromotionBanner = ({ content, costcoVariables, lightBanner }) => {
  const [openLearnMore, setOpenLearnMore] = useState(false);

  const isEnabled = find(costcoVariables, ['name', '{promotionEnabled}'])?.value;

  if (!isEnabled) return null;

  const banner = content[COSTCO_PROMOTION_LEARN];
  const onClickLearnMore = (status) => setOpenLearnMore(status);
  const dialogContent = {
    title: replaceAllVariables('{promotionalTitle}', costcoVariables, ''),
    note: replaceAllVariables('{promotionalNote}', costcoVariables, ''),
    disclaimer: replaceAllVariables('{promotionalPricingDisclaimer}', costcoVariables, ''),
  }

  return (
    <>
      <div
        className={classnames(
          setTheme(styles.promotionBanner, banner, styles),
          lightBanner && styles.lightBanner,
        )}
      >
        <div className={styles.content}>
          <div className={styles.controlledContent}>
            <div className={styles.descriptionWrapper}>
              <div className={styles.promotionApplied}>
                {/* {!lightBanner && <img src={PromotionWhiteIcon} alt="" />} */}
                {lightBanner && <img src={PromotionIcon} alt="" />}
              </div>
              <p className={styles.title}>
                {banner.title}
                <sup
                  className={styles.supScript}
                  aria-describedby="costco-promo-terms-id"
                >
                  {' '}
                  2
                </sup>
              </p>
              <Button
                className={lightBanner ? styles.btnLight : styles.btn}
                text={banner.buttonLabel}
                onClick={() => onClickLearnMore(true)}
                color={lightBanner ? 'dark' : ''}
              />
            </div>
          </div>
        </div>
      </div>
      <CostcoPromotionDetails
        open={openLearnMore}
        onClose={() => onClickLearnMore(false)}
        setStatus={setOpenLearnMore}
        content={dialogContent}
      />
    </>
  );
};

CostcoPromotionBanner.propTypes = {
  content: PropTypes.object,
  costcoVariables: PropTypes.object,
  lightBanner: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  costcoVariables: selectCostcoVariables(),
});

export default connect(mapStateToProps, null)(CostcoPromotionBanner);
